<template>
  <el-select ref="reason" v-model="selected" v-on:keyup.native.enter="enter" v-loading="loading" :size="size" filterable
    placeholder="Selecione  uma opção" @change="update()">
    <el-option v-for="row of reasonList" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>
<script>
import { RequestInfoService } from "@/services/customers/request.info.services";

export default {
  name: "RequestInfoReasonList",
  props: ["size", "current"],
  data() {
    return {
      reasonList: [],
      loading: false,
      selected: "",
    };
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    },
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      RequestInfoService.reason()
        .then((response) => {
          vm.reasonList = response;
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => vm.loading = false);
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>
